import React, { Fragment, useState, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";

import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import {
  Typography,
  Box,
  Tab,
  Tabs,
  AppBar,
  Slide,
  Snackbar,
  TextField,
  Button,
  Grid,
  Dialog,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Cancel, SaveAlt, Save } from "@material-ui/icons";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import Papa from "papaparse";
import Moment from "moment";
import axios from "axios";

import LoadClase from "components/services/LoadClase";
import LoadParentesco from "components/services/LoadParentesco";
import imgLoader from "assets/img/progress.gif";
import exampleCSV from "assets/img/exampleCSV2.png";

import { cardBodyStyle } from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`action-tabpanel-${index}`}
      aria-labelledby={`action-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `action-tab-${index}`,
    "aria-controls": `action-tabpanel-${index}`,
  };
}

export default function NewPersonalAdmin(props) {
  const classes = useStyles();
  const theme = useTheme();

  const [openAlert, setOpenAlert] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");
  const [errorServer, setErrorServer] = useState(false);
  const [loaders, setLoaders] = useState(false);
  const [loadersStart, setloadersStart] = useState(false);
  const [loadersSave, setLoadersSave] = useState(false);
  const [valueTabs, setValueTabs] = React.useState(0);
  const [disabledMasive, setDisabledMasive] = useState(true);
  const [rowsImport, setRowsImport] = useState([]);
  const [rowsAlert, setRowsAlert] = useState([]);
  const [rowsAlertData, setRowsAlertData] = useState([]);
  // const [rows, setRows] = useState([]);
  const [exitAlert, setExitAlert] = useState(false);

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  const [values, setValues] = useState({
    certificado: "",
    poliza_n: "",
    cedula: "",
    nombres: "",
    // apellidos: "",
    clase_id: "",
    clasedata: [],
    parentesco_id: "",
    parentescodata: [],
    email_personal: "",
    celular: "",
    fecha_inclusion: "",
    fecha_nacimiento: "",
    errorCertificado: false,
    errorPoliza: false,
    errorNombres: false,
    //errorApellidos: false,
    errorCedula: false,
    errorFechaInclusion: false,
    errorFechaNacimiento: false,
    errorParentesco: false,
    errorClase: false,
  });

  /*useEffect(() => {
    const fetchData = async () => {
      setloadersStart(true);
      setRows([]); // Resetear datos mientras se carga

      try {
        const response = await axios.get(
          `${urlServices}routes_personal.php?keyAplication=${keyAplication}`,
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        if (response.data.code === 1) {
          setRows(response.data.data);
        } else if (response.data.code === 0) {
          setRows([]);
        } else {
          setMensaje("Error en la estructura de la respuesta");
          setOpenAlert(true);
          setError("error");
        }
      } catch (error) {
        let errorMessage = "Error de conexión";

        if (error.response) {
          // Error de respuesta HTTP
          errorMessage = `Error ${error.response.status}: ${error.response.statusText}`;
        } else if (error.request) {
          // La petición fue hecha pero no hubo respuesta
          errorMessage = "No se recibió respuesta del servidor";
        }

        setMensaje(errorMessage);
        setOpenAlert(true);
        setError("error");
        setRows([]);
        console.error("Error en dataRows:", error);
      } finally {
        setloadersStart(false);
      }
    };

    fetchData();
  }, [keyAplication, urlServices]); // Agregar dependencias relevantes
*/

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorCertificado: false,
      errorPoliza: false,
      errorNombres: false,
      //errorApellidos: false,
      errorCedula: false,
    });

    setDisabledMasive(false);
    setOpenAlert(false);
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const submitForm = (e) => {
    e.preventDefault();
    setOpenAlert(false);
    setErrorServer(false);

    if (valueTabs === 0) {
      if (values.nombres.length === 0) {
        setValues({ ...values, errorNombres: true });
        setMensaje('El campo "Nombres" es obligatorio.');
        setOpenAlert(true);
        setError("error");
      } /* else if (values.apellidos.length === 0) {
        setValues({ ...values, errorApellidos: true });
        setMensaje('El campo "Apellidos" es obligatorio.');
        setOpenAlert(true);
        setError("error");
      }*/ else if (values.fecha_inclusion.length === 0) {
        setValues({ ...values, errorFechaInclusion: true });
        setMensaje('El campo "Fecha de inclusión" es obligatoria.');
        setOpenAlert(true);
        setError("error");
      } else if (values.clase_id.length === 0) {
        setValues({ ...values, errorClase: true });
        setMensaje('El campo "Clase" es obligatorio.');
        setOpenAlert(true);
        setError("error");
      } else if (values.fecha_nacimiento === "") {
        setValues({ ...values, errorFechaNacimiento: true });
        setMensaje('El campo "Fecha de nacimiento" es obligatorio.');
        setOpenAlert(true);
        setError("error");
      } else if (values.parentesco_id.length === 0) {
        setValues({ ...values, errorParentesco: true });
        setMensaje('El campo "Parentesco" es obligatorio.');
        setOpenAlert(true);
        setError("error");
      } else if (values.certificado.length === 0) {
        setValues({ ...values, errorCertificado: true });
        setMensaje('El campo "Certificado" es obligatorio.');
        setOpenAlert(true);
        setError("error");
      } else if (values.poliza_n.length === 0) {
        setValues({ ...values, errorPoliza: true });
        setMensaje('El campo "Póliza" es obligatorio.');
        setOpenAlert(true);
        setError("error");
      } else if (
        values.cedula.length === 0 &&
        parseInt(values.parentesco_id) === 1
      ) {
        setValues({ ...values, errorCedula: true });
        setMensaje('El campo "Cédula" es obligatoria al titular.');
        setOpenAlert(true);
        setError("error");
      } else {
        setLoaders(true);

        const dataValue = {
          poliza_n: values.poliza_n,
          cedula: values.cedula,
          certificado: values.certificado,
          clase_id: values.clase_id,
          nombres: values.nombres,
          // apellidos: values.apellidos,
          celular: values.celular,
          correo_electronico: values.email_personal,
          parentesco_id: values.parentesco_id,
          fecha_nacimiento: values.fecha_nacimiento,
          fecha_inclusion: values.fecha_inclusion,
          keyAplication: keyAplication,
        };

        axios
          .post(`${urlServices}routes_personalinsert.php`, dataValue, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            if (response.data.code === 1) {
              setLoaders(false);

              setValues({
                ...values,
                certificado: "",
                poliza_n: "",
                cedula: "",
                nombres: "",
                //apellidos: "",
                clase_id: "",
                clasedata: [],
                parentesco_id: "",
                parentescodata: [],
                email_personal: "",
                celular: "",
                fecha_inclusion: "",
                fecha_nacimiento: "",
              });

              setOpenAlert(true);
              setMensaje("Registro guardado con éxito.");
              setError("success");

              props.callBackRefresh();
            } else if (response.data.code === 0) {
              setLoaders(false);

              setMensaje("Error al registrar los datos.");
              setOpenAlert(true);
              setError("error");
            }
          })
          .catch((e) => {
            setLoaders(false);

            setMensaje("Error de conexión, intente más tarde.");
            setOpenAlert(true);
            setError("error");
            setErrorServer(true);
          });
      }
    } else if (valueTabs === 1) {
      setLoadersSave(true);

      let dataApplicants = rowsImport.length,
        n = 0;

      if (dataApplicants > 0) {
        setTimeout(() => {
          // rowsImport.map((row1) => {
          //   const insert = async () => {
          //    row1.keyAplication = keyAplication;

          const datos = {
            keyAplication: keyAplication,
            data: rowsImport,
          };

          // await axios
          axios
            .post(`${urlServices}routes_personalinsertmultiples.php`, datos, {
              headers: {
                "Content-Type": "application/json",
              },
            })
            .then(
              (response) => {
                if (response.data.code === 1) {
                  setOpenAlert(true);
                  setMensaje("Datos registrados con éxito.");

                  setRowsImport([]);
                  setValueTabs(0);
                  setDisabledMasive(true);
                  setLoadersSave(false);

                  setTimeout(() => {
                    props.callBackRefresh();
                    setLoaders(false);
                  }, 1500);
                } else if (response.data.code === 0) {
                } else {
                }
              },
              (error) => {
                console.log(error);
                setErrorServer(true);
                setLoadersSave(false);
              },
            );
          //   };

          //   insert();
          //   n++;
          // });
        }, 1000);

        /* if (n === dataApplicants) {
          setOpenAlert(true);
          setMensaje("Datos registrados con éxito.");

          setRowsImport([]);
          setValueTabs(0);
          setDisabledMasive(true);

          setTimeout(() => {
            props.callBackRefresh();
            setLoaders(false);
          }, 1500);
        }*/
      } else {
        setLoadersSave(false);
        setMensaje("El archivo no puede estar vacío.");
        setOpenAlert(true);
        setError("error");
      }
    }
  };

  const searchIndentificacion = async (data) => {
    await axios
      .get(
        `${urlServices}routes_personaldocument.php?document=${data}&keyAplication=${keyAplication}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      .then((response) => {
        if (response.data.code === 1) {
          setDisabledMasive(true);
          setValues({ ...values, errorCedula: true });
          setMensaje("Persona ya registrada con esta cédula.");
          setOpenAlert(true);
          setError("error");
        } else if (response.data.code === 0) {
          setDisabledMasive(false);
        }
      })
      .catch((e) => {
        setError(true);
      });
  };

  const arrayDNY = (data) => {
    if (data.length > 0) {
      return (
        <Fragment>
          <TableContainer>
            <Table size="small" aria-label="a dense table">
              <TableBody>
                <TableRow style={{ backgroundColor: "#F2F2F2" }}>
                  <TableCell
                    colSpan={9}
                    style={{
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    HAY QUE ELIMINAR ESTOS DATOS DEL DOCUMENTO QUE DESEA SUBIR
                  </TableCell>
                </TableRow>
                <TableRow style={{ backgroundColor: "tomato" }}>
                  <TableCell
                    colSpan={9}
                    style={{
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    ESTAS CÉDULAS YA ESTÁN REGISTRADAS CON ESTOS USUARIOS EN EL
                    SISTEMA
                  </TableCell>
                </TableRow>
                <TableRow className={classes.titleFilterAction}>
                  <TableCell
                    style={{
                      fontWeight: "600",
                      textAlign: "center",
                      fontSize: 14,
                      backgroundColor: "#F2F2F2",
                    }}
                  >
                    Cédula
                  </TableCell>
                  <TableCell
                    style={{
                      fontWeight: "600",
                      textAlign: "center",
                      fontSize: 14,
                      backgroundColor: "#F2F2F2",
                    }}
                  >
                    Nombres
                  </TableCell>
                </TableRow>
                {data.map((row, i) => {
                  return (
                    <TableRow key={i}>
                      <TableCell
                        style={{
                          textAlign: "center",
                          fontSize: 12,
                          color: "red",
                        }}
                      >
                        {row.cedula}
                      </TableCell>
                      <TableCell
                        style={{
                          textAlign: "center",
                          fontSize: 12,
                          color: "red",
                        }}
                      >
                        {row.nombres}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Fragment>
      );
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleDateNacimientoChange = (e) => {
    setValues({
      ...values,
      fecha_nacimiento: e.target.value,
      errorFechaNacimiento: false,
    });
  };

  const handleDateInclusionChange = (e) => {
    setValues({
      ...values,
      fecha_inclusion: e.target.value,
      errorFechaInclusion: false,
    });
  };

  const handleIndentificacionChange = (e) => {
    setValues({
      ...values,
      cedula: e.target.value,
      errorCedula: false,
    });

    searchIndentificacion(e.target.value);
  };

  const changeClase = (data) => {
    setValues({
      ...values,
      clase_id: data !== null ? data.id : "",
      clasedata: data !== null ? data : [],
      errorClase: false,
    });
  };

  const changeParentesco = (data) => {
    setValues({
      ...values,
      parentesco_id: data !== null ? data.id : "",
      parentescodata: data !== null ? data : [],
      errorParentesco: false,
    });
  };

  const handleChangeIndex = (index) => {
    setValueTabs(index);
  };

  const handleChangeTabs = (event, newValue) => {
    setValues({
      ...values,
      fecha_emision: "",
      identificacion: "",
      nombres: "",
      // apellidos: "",
      tipo_estudios: "",
      programa_academico: "",
      gender_id: "",
      genderdata: [],
      gendername: "",
      email_personal: "",
      email_institucional: "",
      celular: "",
      telefono: "",
      fecha_nacimiento: "",
      inicio_clases: "",
    });

    setDisabledMasive(true);
    setValueTabs(newValue);
  };

  const changeHandler = (event) => {
    setOpenAlert(false);
    setRowsAlert(false);
    setRowsAlertData([]);

    if (event.target.files[0] !== undefined) {
      // Passing file data (event.target.files[0]) to parse using Papa.parse
      Papa.parse(event.target.files[0], {
        header: true,
        skipEmptyLines: true,
        complete: function (results) {
          const rowsArray = [];
          const valuesArray = [];
          const out = [];
          const empty = [];

          // Iterating data to get column name and their values
          results.data.map((d) => {
            rowsArray.push(Object.keys(d));
            valuesArray.push(Object.values(d));
          });

          // Parsed Data Response in array format
          // setParsedData(results.data);

          // Filtered Column Names
          // setTableRows(rowsArray[0]);

          // Filtered Values
          // setValues(valuesArray);

          results.data.map((row1) => {
            /*console.log("INICIO",row1.Fecha_Emision.length);
            console.log("Fecha_Emision",row1.Identificacion.length);
            console.log("Fecha_Emision",row1.Nombre.length);
            console.log("Fecha_Emision",row1.Apellido.length);
            console.log("Fecha_Emision",row1.Tipo_Estudios.length);
            console.log("Fecha_Emision",row1.Programa_Academico.length);
            console.log("Fecha_Emision",row1.Genero.length);
            console.log("Fecha_Emision",row1.Correo_Personal.length);
            console.log("Fecha_Emision",row1.Correo_Institucional.length);
            console.log("Fecha_Emision",row1.Celular.length);
            console.log("Fecha_Emision",row1.Telefono.length);
            console.log("Fecha_Emision",row1.Fecha_Nacimiento.length);
            console.log("FINAL",row1.Inicio_Clases.length);*/
            const tieneDatos = Object.values(row1).some(
              (elemento) => elemento !== "",
            );

            if (tieneDatos) {
              if (row1.Nombres === "" || row1.Nombres === undefined) {
                empty.push({ nombre: true });
              }

              /*if (row1.Apellidos === "") {
                empty.push({ apellido: true });
              }*/

              if (row1.Clase === "" || row1.Clase === undefined) {
                empty.push({ clase: true });
              }

              if (
                Moment(row1.Fecha_inclusion).format("YYYY-MM-DD") ===
                  "Invalid date" ||
                row1.Fecha_inclusion === undefined
              ) {
                empty.push({ fecha_inclusion: true });
              }

              if (
                Moment(row1.Fecha_nacimiento).format("YYYY-MM-DD") ===
                  "Invalid date" ||
                row1.Fecha_nacimiento === undefined
              ) {
                empty.push({ fecha_nacimiento: true });
              }

              const valuesNuew = {
                poliza_n: row1.Poliza_n,
                cedula: row1.Cedula,
                certificado: row1.Certificado,
                clase_id: row1.Clase === "ACTIVO" ? 1 : 2,
                nombres: row1.Nombres,
                //apellidos: row1.Apellidos,
                celular: row1.Celular,
                correo_electronico: row1.Correo_electronico,
                parentesco_id:
                  row1.Parentesco === "TITULAR"
                    ? 1
                    : row1.Parentesco === "CONYUGUE"
                      ? 2
                      : 3,
                fecha_nacimiento: row1.Fecha_nacimiento,
                fecha_inclusion: row1.Fecha_inclusion,
              };

              out.push(valuesNuew);
            }
          });

          if (empty.length > 0) {
            setExitAlert(true);
            setMensaje(
              "Hay celdas vacías o formato de fecha no aceptada que son obligatoria para registrar, revise las columnas FECHA INCLUSIÓN con formato 2024-01-01, FECHA NACIMIENTO con formato 2024-01-01, no se permite formato 1900-01-00, NOMBRES = no vacío, PARENTESCO = no vacío y CLASE = no vacío o verifique que no haya modificado la cabecera del formato original.",
            );
            setOpenAlert(true);
            setError("error");
          } else if (out.length === 0) {
            setExitAlert(true);
            setMensaje(
              "El documento no puede estar vacío o revisar que estén todos los datos obligatorios.",
            );
            setOpenAlert(true);
            setError("error");
          } else {
            /* let datos = [];
            let datosIgual = [];

            rows.map((row2) => {
              datos = out.filter((filtered) => filtered.cedula === row2.cedula);

              if (datos.length > 0) {
                if (row2.cedula !== "") {
                  datosIgual.push({
                    cedula: row2.cedula,
                    nombres: row2.nombres,
                    // apellidos: row2.apellidos,
                  });
                }
              }
            });

            if (datosIgual.length === 0) {*/
            setRowsImport(out);
            setDisabledMasive(false);
            /*} else {
              setExitAlert(true);
              setRowsAlert(true);
              setRowsAlertData(datosIgual);
            }*/
          }
        },
      });
    }
  };

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="md"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        style={{ zIndex: 100 }}
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container spacing={1} className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                <div className={classes.titleCardFilter}>Nuevo personal</div>
                <div className={classes.lineBottom}></div>
                <br></br>
              </Grid>
              {loadersStart ? (
                <Grid item xs={12} md={12}>
                  <center>
                    <img
                      src={imgLoader}
                      alt="loader"
                      style={{
                        width: 60,
                        objectFit: "contain",
                        marginTop: 25,
                      }}
                    />
                  </center>
                </Grid>
              ) : (
                <Grid item xs={12} md={12}>
                  <AppBar position="static" color="default">
                    <Tabs
                      value={valueTabs}
                      onChange={handleChangeTabs}
                      indicatorColor="primary"
                      textColor="primary"
                      variant="fullWidth"
                      aria-label="action tabs example"
                    >
                      <Tab
                        label="Carga manual"
                        {...a11yProps(0)}
                        style={{ color: "#000" }}
                      />
                      <Tab
                        label="Carga masiva"
                        {...a11yProps(1)}
                        style={{ color: "#000" }}
                      />
                    </Tabs>
                  </AppBar>
                  <SwipeableViews
                    axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                    index={valueTabs}
                    onChangeIndex={handleChangeIndex}
                  >
                    <TabPanel value={valueTabs} index={0} dir={theme.direction}>
                      <Grid
                        container
                        spacing={3}
                        style={{
                          backgroundColor: "#f8f8f8",
                          borderRadius: 5,
                          padding: 10,
                        }}
                      >
                        <Grid item xs={12} sm={4}>
                          <TextField
                            autoComplete="off"
                            name="nombres"
                            value={values.nombres}
                            onChange={handleChange("nombres")}
                            label="Nombres"
                            error={values.errorNombres}
                            fullWidth
                            required
                          />
                        </Grid>
                        {/*<Grid item xs={12} sm={4}>
                          <TextField
                            autoComplete="off"
                            name="apellidos"
                            value={values.apellidos}
                            onChange={handleChange("apellidos")}
                            label="Apellidos"
                            error={values.errorApellidos}
                            fullWidth
                            required
                          />
                        </Grid>*/}
                        <Grid item xs={12} md={4}>
                          <TextField
                            name="dateInclusion"
                            label="Fecha de inclusión"
                            type="date"
                            value={values.fecha_inclusion}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onChange={(e) => handleDateInclusionChange(e)}
                            autoComplete="off"
                            error={values.errorFechaInclusion}
                            required
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            autoComplete="off"
                            name="cedula"
                            value={values.cedula}
                            onChange={handleIndentificacionChange}
                            label="Cédula"
                            error={values.errorCedula}
                            fullWidth
                            required
                            type="number"
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <LoadClase
                            refresh={changeClase}
                            value={values.clasedata}
                            error={values.errorClase}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            name="date"
                            label="Fecha de nacimiento"
                            type="date"
                            value={values.fecha_nacimiento}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onChange={(e) => handleDateNacimientoChange(e)}
                            autoComplete="off"
                            error={values.errorFechaNacimiento}
                            required
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            autoComplete="off"
                            name="email_personal"
                            value={values.email_personal}
                            onChange={handleChange("email_personal")}
                            label="Correo personal"
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <LoadParentesco
                            refresh={changeParentesco}
                            value={values.parentescodata}
                            error={values.errorParentesco}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            autoComplete="off"
                            name="celular"
                            value={values.celular}
                            onChange={handleChange("celular")}
                            label="celular"
                            fullWidth
                            type="number"
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            autoComplete="off"
                            name="certificado"
                            value={values.certificado}
                            onChange={handleChange("certificado")}
                            label="Certificado"
                            fullWidth
                            required
                            error={values.errorCertificado}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            autoComplete="off"
                            name="poliza_n"
                            value={values.poliza_n}
                            onChange={handleChange("poliza_n")}
                            label="Póliza"
                            fullWidth
                            required
                            error={values.errorPoliza}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          {errorServer ? (
                            <Alert severity="error">
                              Error en la consulta al servidor
                            </Alert>
                          ) : (
                            ""
                          )}
                        </Grid>
                      </Grid>
                    </TabPanel>
                    <TabPanel value={valueTabs} index={1} dir={theme.direction}>
                      <Grid
                        container
                        spacing={1}
                        style={{
                          backgroundColor: "#f8f8f8",
                          borderRadius: 5,
                          padding: 10,
                        }}
                      >
                        <Grid item xs={12} md={12}>
                          <Alert severity="warning">
                            <AlertTitle>IMPORTANTE</AlertTitle>- La
                            columna&nbsp;
                            <strong>
                              Fecha Inclusión y Fecha de nacimiento
                            </strong>{" "}
                            es importante mantener este formato ej:{" "}
                            <strong>2000-10-20</strong> seleccionando formato de
                            celdas "Fecha" en el excel, no se permite formato
                            1900-01-00.
                            <br></br>- La columna{" "}
                            <strong>Cédula y Celular</strong> es importante
                            mantener este formato ej: en formato de "TEXTO" para
                            agregar al inicio 0 si lo requiere. <br></br>- La
                            columna <strong>Clase</strong> es importante
                            mantener este formato ej:{" "}
                            <strong>ACTIVO o JUBILADO</strong> <br></br>- La
                            columna <strong>Parentesco</strong> es importante
                            mantener este formato ej:{" "}
                            <strong>TITULAR, HIJO y CONYUGUE</strong> <br></br>-
                            Al finalizar con el archivo excel, deberá ir a{" "}
                            <strong>"ARCHIVO y GUARDAR COMO"</strong>,
                            seleccionar el formato del archivo tipo&nbsp;
                            <strong>
                              "(CSV CODIFICADO EN UTF-8 (DELIMITADO POR
                              COMAS))"{" "}
                            </strong>
                            y <strong>"GUARDAR"</strong>.<br></br>
                            <br></br>
                            <b>Ejemplo:</b>
                            <center>
                              <img
                                src={exampleCSV}
                                alt="example"
                                style={{
                                  width: "100%",
                                  objectFit: "contain",
                                }}
                              />
                            </center>
                          </Alert>
                        </Grid>
                        <Grid item xs={12} md={12} style={{ marginTop: "3%" }}>
                          {rowsAlert ? arrayDNY(rowsAlertData) : null}
                        </Grid>
                        <br></br>
                        <br></br>
                        <Grid item xs={12} md={12}>
                          <center>
                            {exitAlert ? (
                              <Alert variant="filled" severity="error">
                                <b>
                                  Cierre nuevamente la ventana para evitar
                                  errores.
                                </b>
                              </Alert>
                            ) : null}
                          </center>
                        </Grid>
                        <br></br>
                        <br></br>
                        <Fragment>
                          <Grid item xs={12} md={12}>
                            <center>
                              <input
                                accept=".csv"
                                style={{ display: "none" }}
                                onChange={changeHandler}
                                id="contained-button-file"
                                multiple
                                type="file"
                                name="filecsv"
                              />
                              <a
                                href={"/document/csv_personal.csv"}
                                download="csv_personal.csv"
                              >
                                <Button
                                  className={classes.buttonLeftSteps2}
                                  startIcon={<SaveAlt />}
                                >
                                  Descargar formato
                                </Button>
                              </a>
                              <label htmlFor="contained-button-file">
                                <Button
                                  className={classes.buttonContactGreen}
                                  component="span"
                                >
                                  Subir documento
                                </Button>
                              </label>
                              <br></br>
                              <br></br>
                            </center>
                          </Grid>
                        </Fragment>
                      </Grid>
                    </TabPanel>
                  </SwipeableViews>
                </Grid>
              )}
              <Grid item xs={12} md={12}>
                {loadersStart ? null : (
                  <>
                    {loaders ? (
                      <center>
                        <img
                          src={imgLoader}
                          alt="loader"
                          style={{
                            width: 60,
                            objectFit: "contain",
                            marginTop: 25,
                          }}
                        />
                      </center>
                    ) : (
                      <Fragment>
                        {loadersSave ? (
                          <center>
                            <img
                              src={imgLoader}
                              alt="loader"
                              style={{
                                width: 60,
                                objectFit: "contain",
                                marginTop: 25,
                              }}
                            />
                          </center>
                        ) : (
                          <center>
                            <Button
                              className={classes.buttonSubmit2}
                              onClick={submitForm}
                              disabled={disabledMasive}
                              startIcon={<Save />}
                            >
                              Guardar
                            </Button>
                          </center>
                        )}
                      </Fragment>
                    )}
                  </>
                )}
              </Grid>
            </Grid>
            <Snackbar
              open={openAlert}
              autoHideDuration={20000}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              onClose={handleClose}
            >
              <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
                <Alert
                  onClose={handleClose}
                  severity={error === "error" ? "error" : "success"}
                  elevation={6}
                  variant="filled"
                >
                  {mensaje}
                </Alert>
              </Slide>
            </Snackbar>
          </Fragment>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog(true)}>
            <Cancel />
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
